module.exports = __webpack_public_path__ + "img/nest_clock.a8c143b5.svg";